module.exports = __webpack_public_path__ + "static/media/propic.28bea06f.jpg";